'use strict';
import 'taos';

import Header from './components/header';
import Helper from './partials/helper';
import Forms from './forms/form';

new Header();
new Helper();
new Forms();

const componentMapping = {
    hero_home: () => import('./components/hero_home'),
    single_hero_home: () => import('./components/single_hero_home'),
    testimonials: () => import('./components/testimonials'),
    all_solutions: () => import('./components/all_solutions'),
    info_cards_icon: () => import('./components/info_cards_icon'),
    tabs_content: () => import('./components/tabs_content'),
    cases: () => import('./components/cases'),
    faq: () => import('./components/faq'),
    our_partner: () => import('./components/our_partner'),
    featured_news: () => import('./components/featured_news'),
    last_news: () => import('./components/last_news'),
    leaders: () => import('./components/leaders'),
    how_its_work:() =>import('./components/how_its_work'),
    institucional_video: () => import('./components/institucional_video'),
    timeline: () => import('./components/timeline'),
    leaders_list: () => import('./components/leaders_list'),
    certifications: () => import('./components/certifications'),
    polices_initiatives: () => import('./components/polices_initiatives'),
    ours_commitments: () => import('./components/ours_commitments'),
    ours_address: () => import('./components/ours_address'),
    featured_news_internal: () => import('./components/featured_news_internal'),
    team_testimonials: () => import('./components/team_testimonials'),
    benefits: () => import('./components/benefits'),
    contact: () => import('./components/contact'),
    radar_form: () => import('./components/radar_form'),
    form_newsletter: () => import('./components/form_newsletter'),
    palestrantes: () => import('./components/palestrantes'),
    cards_edition: () => import('./components/cards_edition'),
    zig_zag: () => import('./components/zig_zag'),
    banner_fixed: () => import('./components/banner_fixed'),
};

(async function initializeComponents() {
    for (const [dataComponent, importComponent] of Object.entries(componentMapping)) {
        if (document.querySelector(`[data-component="${dataComponent}"]`)) {
            try {
                const { default: ComponentClass } = await importComponent();
                document.querySelectorAll(`[data-component="${dataComponent}"]`).forEach((componentElement) => {
                    new ComponentClass(componentElement);
                });
            } catch (error) {
                console.error(`Error loading component ${dataComponent}:`, error);
            }
        }
    }
})();
